export default (defaultAppearanceMode) => ({

  darkMode: false,

  init() {
    const mode = this.getCookie('appearance_mode');

    // If the cookie does not exist (undefined), use the default mode from admin settings
    if (mode === undefined) {
      this.darkMode = defaultAppearanceMode === 'dark';
    }
    // If the cookie is set to 'light', enable light mode
    else if (mode === 'light') {
      this.darkMode = false;
    }
    // If the cookie is set to 'dark', enable dark mode
    else if (mode === 'dark') {
      this.darkMode = true;
    }

    this.updateBodyClass();
  },

  toggleDarkMode() {
    // Toggle darkMode state
    this.darkMode = !this.darkMode;
    this.updateBodyClass();
    this.setCookie('appearance_mode', this.darkMode ? 'dark' : 'light', 7);
  },

  updateBodyClass() {
    // Add or remove the 'dark-mode' class based on the current mode
    if (this.darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  },

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  },

  setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
});
